import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

type Props = {
  value: string[] | null;
};

const PermissionNameList = ({ value }: Props) => {
  let formattedValue: ReactNode;

  if (!value) {
    formattedValue = <FormattedMessage id="all" />;
  } else if (value.length === 0) {
    formattedValue = <FormattedMessage id="NONE" />;
  } else {
    formattedValue = value.join(", ");
  }

  return <span className="names-list">{formattedValue}</span>;
};

export default PermissionNameList;
